// extracted by mini-css-extract-plugin
module.exports = {"button":"FormDetailsButton_button__AqCKZ"};